import { Link } from "react-router-dom";
import { ArrowRight, Users } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { useSite } from "@/context/SiteContext";

// Clear entry to the third-party section, placed after Fabrice's apps.
export const ThirdPartyEntry = ({ testId = "third-party-entry", slim = false }) => {
  const { t } = useI18n();
  const { marketplace } = useSite();
  if (!marketplace) return null;
  if (slim) return (  // same box as the slim custom-plan CTA: one short line + one button, stacked on phones
    <div className="flex w-full min-w-0 max-w-full flex-col items-stretch gap-3 rounded-2xl border border-[rgba(245,197,66,0.3)] bg-black/30 px-4 py-3 sm:flex-row sm:flex-wrap sm:items-center" data-testid={testId}>
      <p className="w-full min-w-0 text-start text-sm text-neutral-200 hyphens-none [overflow-wrap:break-word] [word-break:normal] sm:w-auto sm:flex-1 sm:basis-64">{t("market.title")}</p>
      <Link to="/developpeurs" className="btn-gold btn-sm min-h-[44px] w-full max-w-full justify-center hyphens-none whitespace-normal text-center sm:w-auto sm:shrink-0" data-testid={`${testId}-link`}>
        <Users className="h-4 w-4 shrink-0" /> {t("market.entryCta")}
      </Link>
    </div>
  );
  return (
    <section className="mx-auto max-w-7xl px-4 pt-14 sm:px-8" data-testid={testId}>
      <Link
        to="/developpeurs"
        className="group flex flex-col gap-4 rounded-3xl border-2 border-amber-400/50 bg-[rgba(40,28,4,0.55)] p-6 transition-colors duration-200 hover:border-amber-300 sm:flex-row sm:items-center"
        data-testid={`${testId}-link`}
      >
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-amber-400 text-black"><Users className="h-6 w-6" /></span>
        <span className="min-w-0 flex-1">
          <span className="block font-display text-sm font-bold uppercase tracking-wider text-white md:text-base">{t("market.title")}</span>
          <span className="mt-1 block text-sm text-neutral-300">{t("market.entryText")}</span>
        </span>
        <span className="inline-flex items-center gap-2 self-start text-sm font-semibold text-amber-200 sm:self-auto">
          {t("market.entryCta")} <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1 rtl:-scale-x-100" />
        </span>
      </Link>
    </section>
  );
};
